import api from '@/services/Api';

export default {
  validateCoupon(couponCode) {
    const data = { coupon_code: couponCode };
    const query = new URLSearchParams(data).toString();
    return api().get('/subscription-coupon/validate?' + query);
  },
};
